<template>
  <label v-if="label" class="block text-sm font-medium dark:text-white" >{{ label }}</label>
  <div v-bind="attrs"></div>
  <ErrorTag :is-error="isError" :model="model" :required="false" :error-message="errorMessage"  />
</template>
<script setup lang="ts">
import { onMounted, useAttrs, ref, computed } from 'vue'
import { EditorView, basicSetup } from 'codemirror'
import { MySQL, sql } from '@codemirror/lang-sql'
import { javascript } from '@codemirror/lang-javascript'
import { json } from "@codemirror/lang-json";
import { html  } from '@codemirror/lang-html'
import { autocompletion, acceptCompletion, startCompletion, completionStatus } from '@codemirror/autocomplete'
import { keymap } from '@codemirror/view'
import { getIsError } from '@/modules/Core/usings/generales';
import type { ErrorObject } from '@vuelidate/core'
type ModelValue = string | null
const attrs = useAttrs()
const model = defineModel<ModelValue>()
const editor = ref();
const props = defineProps<{
  label?: string
  tipo: string
  error?: string | Array<ErrorObject> | null | undefined
  height?: string
}>()
const { height = 'auto' } = props
const errorMessage = computed(()=> props.error)
const isError = computed(() => {
  const isArray = Array.isArray(props.error)
  return getIsError(props, isArray)
})
const customTheme = EditorView.theme({
  "&": { height: height }, // o width
  ".cm-scroller": { overflow: "auto" }
});
onMounted(() => {
  const lenguajes = { sql: sql({ dialect: MySQL }), js: javascript(), html: html(), json: json() } as object

  // Configuración de keymap personalizado para Tab
  const customKeymap = keymap.of([
    {
      key: "Tab",
      run: (view) => {
        // Verificar si hay autocompletado activo usando completionStatus
        const status = completionStatus(view.state)
        if (status === "active") {
          return acceptCompletion(view)
        }
        // Si no hay autocompletado, iniciar autocompletado
        return startCompletion(view)
      }
    }
  ])

  editor.value = new EditorView({
    doc: model.value || '',
    extensions: [
      basicSetup,
      lenguajes[props.tipo],
      customTheme,
      autocompletion(),
      customKeymap,
      EditorView.updateListener.of((update) => {
        /* if (update.docChanged && !update.changes.some((change) => change.isUser)
             ) {
               return;
             }*/
        model.value = update.state.doc.toString();
      }),
    ],
    parent: document.querySelector(`#${attrs.id}`) || undefined
  });
  if (model.value) {
    editor.value.dispatch({
      changes: { from: 0, to: editor.value.state.doc.length, insert: model.value }
    });
  }
})
</script>
<style>
.cm-scroller {
  /* max-height: 400px; */
  overflow: auto
}
</style>
